import React, { useState } from 'react';

export interface IImageProps {
    src: string;
    className?: string;
    usePlaceholder?: true;
}

const Image: React.FC<IImageProps> = ({ src, className, usePlaceholder }) => {
    const [loadingFailed, setLoadingFailed] = useState(false);

    return (
        <>
            {!loadingFailed ? (
                <img className={className} src={src} onError={() => setLoadingFailed(true)} />
            ) : (
                <>{usePlaceholder ? <div className={className + ' placeholder-image'} /> : null}</>
            )}
        </>
    );
};

export default Image;
